// کامپوننت داشبورد
import React from 'react'
import {   
  Col, 
  Row,   
  Card, 
  Space, 
  Typography,
  Input, 
  Statistic, 
  theme,
  Button,
  Badge,
  Progress,
  Divider
} from 'antd';
import {
  CoffeeOutlined,
  HistoryOutlined,
  PlusOutlined,
  SearchOutlined,
  CheckCircleOutlined,
  UserAddOutlined,
  LoginOutlined,
  CarOutlined,
  QuestionCircleOutlined,
  GlobalOutlined,
  InfoCircleOutlined,
  AppstoreOutlined,
  BarChartOutlined,
  TeamOutlined,
  SettingOutlined,
  BellOutlined,
  CalendarOutlined
} from '@ant-design/icons';
import { AppFooter } from './Support/AppFooter'; // کامپوننت فوتر را import کنید
import loginImage from '../assets/img/loginPage.png';
import '../assets/css/charts.css';
const { Title, Text, Paragraph } = Typography;
const { useToken } = theme;
const { Search } = Input;



export const DashboardComponent = ({ setLoading, showMessage, handleViewChange }) => {
  const userRole = localStorage.getItem('role');
  const isSuperAdmin = userRole === 'SuperAdmin';
  const isAdmin = userRole === 'Admin';
  const isReception = userRole === 'Reception';
  
  const pdfUrl = "/pdf/reserveHelp.pdf";

  // داده‌های نمونه
  const stats = {
    todayReservations: 0,
    activeRooms: 0,
    pendingFoodOrders: 0,
    occupancyRate: 0,
    revenueToday: '0',
    todayAccepts: 0,
    pendingRequests: 0
  };

  // عملیات سریع
  const quickActions = [
    { key: '6', label: 'رزرو جدید', icon: <PlusOutlined />, color: '#52c41a', roles: ['*'] },
    { key: '16', label: 'رزرو غذا و پارکینگ', icon: <CoffeeOutlined />, color: '#722ed1', roles: ['*'] },
    { key: '12', label: 'جستجوی پیشرفته', icon: <SearchOutlined />, color: '#1890ff', roles: ['SuperAdmin', 'Admin', 'Reception'] },
    { key: '7', label: 'رزروهای من', icon: <HistoryOutlined />, color: '#fa8c16', roles: ['*'] },
    { key: 'website', label: 'وب‌سایت اطلاع رسانی', icon: <GlobalOutlined />, color: '#13c2c2', roles: ['*'] },
    { key: 'about-app', label: 'معرفی برنامه', icon: <InfoCircleOutlined />, color: '#eb2f96', roles: ['*'] }
  ];

  // لینک‌های پشتیبانی
  const supportLinks = {
    website: 'https://hosseinienajafabadiha.com',
    email: 'ali.abedini@gmail.com',
    phone: '031-42748879,80',
    whatsapp: 'https://@hoseinienajafabadiha'
//    whatsapp: 'https://wa.me/989123456789'
  };

  const filteredQuickActions = quickActions.filter(action => 
    action.roles.includes('*') || action.roles.includes(userRole)
  );

  // بخش‌های خاص برای نقش‌های مختلف
  const adminSections = [
    { key: '11', label: 'مدیریت کاربران', icon: <TeamOutlined />, color: '#fa8c16' },
    { key: '8', label: 'تنظیمات سیستم', icon: <SettingOutlined />, color: '#722ed1' },
    { key: '20', label: 'گزارشات اتاق', icon: <BarChartOutlined />, color: '#1890ff' }
  ];

  const todayDate = (() => {
    const today = new Date();
    const options = { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    };
    return `امروز ${today.toLocaleDateString('fa-IR', options)}`;
  })();

  // اعلانات اخیر
  const notifications = [
    { id: 1, text: 'به‌روزرسانی جدید سیستم رزرواسیون', time: '1404/09/05' },
    { id: 2, text: 'شماره کارت جهت پرداخت وتسویه پذیرفته شدگان (4964-9032-6919-6037) بنام حسینیه نجف آبادیها – مشهد مقدس', time: '2 هفته پیش' },
    { id: 3, text: 'تکمیل ظرفیت یک شنبه هر هفته ساعت 8 صبح ', time: 'دیروز' }
  ];

  return (
    <div style={{ padding: 6, minHeight: 'calc(100vh - 80px)' }}>
      {/* هدر داشبورد */}
      <Card
        style={{ marginBottom: '12px' }}
        bodyStyle={{ padding: '16px' }}
      >
        <Row align="middle" gutter={[16, 16]}>
          <Col xs={24} md={21}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
              <Title level={4} style={{ margin: 0 }}>
                👋 سلام، به حسینیه من (سامانه رزرو اتاق در مشهد مقدس) خوش آمدید!
              </Title>
              <Text type="secondary" style={{ fontSize: 13, marginTop: 4 }}>
                {todayDate}
              </Text>
              <Paragraph style={{ marginTop: 4, marginBottom: 0, fontSize: 13 }}>
                🟢 سیستم آنلاین - همه قابلیت‌ها در دسترس هستند.
              </Paragraph>
            </div>
          </Col>

          <Col xs={24} md={3}>
            <div style={{ width: '100%', paddingTop: '100%', position: 'relative' }}>
              <img
                src={loginImage}
                alt="تصویر خوش آمدید"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}
              />
            </div>
          </Col>
        </Row>
      </Card>

      {/* آمار سریع */}
      <Row gutter={[12, 12]} style={{ marginBottom: 12 }}>
        <Col xs={24} sm={6}>
          <Card
            hoverable
            onClick={(isSuperAdmin || isAdmin) ? () => handleViewChange('20') : undefined}
            bodyStyle={{ padding: '12px' }}
          >
            <Statistic
              title={<Text style={{ fontSize: 12 }}>رزرو امروز</Text>}
              value={stats.todayReservations}
              prefix={<CalendarOutlined style={{ fontSize: 16 }} />}
              valueStyle={{ color: '#52c41a', fontSize: 20 }}
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={6}>
          <Card
            hoverable
            onClick={(isSuperAdmin || isAdmin) ? () => handleViewChange('18') : undefined}
            bodyStyle={{ padding: '12px' }}
          >
            <Statistic
              title={<Text style={{ fontSize: 12 }}>سفارشات غذا</Text>}
              value={stats.pendingFoodOrders}
              prefix={<CoffeeOutlined style={{ fontSize: 16 }} />}
              valueStyle={{ color: '#722ed1', fontSize: 20 }}
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={6}>
          <Card
            hoverable
            bodyStyle={{ padding: '12px' }}
          >
            <Statistic
              title={<Text style={{ fontSize: 12 }}>واریز امروز</Text>}
              value={stats.revenueToday}
              prefix={<Text style={{ fontSize: 16 }}>﷼</Text>}
              valueStyle={{ color: '#faad14', fontSize: 20 }}
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={6}>
          <Card
            hoverable
            bodyStyle={{ padding: '12px' }}
          >
            <Statistic
              title={<Text style={{ fontSize: 12 }}>پذیرش امروز</Text>}
              value={stats.occupancyRate}
              suffix="%"
              valueStyle={{ color: '#13c2c2', fontSize: 20 }}
            />
            <Progress 
              percent={stats.occupancyRate} 
              size="small" 
              status="active"
              strokeColor="#13c2c2"
            />
          </Card>
</Col>
      </Row>
   
      {/* عملیات سریع و دسترسی‌های ویژه */}
      <Row gutter={[12, 12]} style={{ marginBottom: 12 }}>
        <Col xs={24} md={16}>
          <Card 
            title={<Text strong style={{ fontSize: 14 }}>عملیات سریع</Text>}
            bodyStyle={{ padding: '12px' }}
          >
            <Row gutter={[8, 8]}>
              {filteredQuickActions.map(action => (
                <Col xs={12} sm={6} key={action.key}>
                  <Card
                    hoverable
                    onClick={() => handleViewChange(action.key)}
                    style={{
                      textAlign: 'center',
                      border: `2px solid ${action.color}20`,
                      background: `${action.color}10`,
                      cursor: 'pointer',
                      height: '100%'
                    }}
                    bodyStyle={{ padding: '8px' }}
                  >
                    <div style={{ fontSize: 20, color: action.color, marginBottom: 2 }}>
                      {action.icon}
                    </div>
                    <Text strong style={{ fontSize: 12 }}>{action.label}</Text>
                  </Card>
                </Col>
              ))}
            </Row>
          </Card>
        </Col>

        {/* بخش اعلانات */}
        <Col xs={24} md={8}>
          <Card 
            title={
              <Space>
                <BellOutlined />
                <Text strong style={{ fontSize: 14 }}>اعلانات اخیر</Text>
              </Space>
            }
            bodyStyle={{ padding: '12px' }}
          >
            <Space direction="vertical" style={{ width: '100%' }}>
              {notifications.slice(0, 3).map(notif => (
                <Card
                  key={notif.id}
                  size="small"
                  style={{ marginBottom: 2 }}
                  bodyStyle={{ padding: '8px' }}
                >
                  <Text style={{ fontSize: 12 }}>{notif.text}</Text>
                  <br />
                  <Text type="secondary" style={{ fontSize: 10 }}>{notif.time}</Text>
                </Card>
              ))}
            </Space>
          </Card>
        </Col>
      </Row>

      {/* بخش مدیران */}
      {(isSuperAdmin || isAdmin) && (
        <Card 
          title={<Text strong style={{ fontSize: 14 }}>دسترسی‌های مدیریتی</Text>}
          style={{ marginBottom: 12 }}
          bodyStyle={{ padding: '12px' }}
        >
          <Row gutter={[8, 8]}>
            {adminSections.map(section => (
              <Col xs={12} sm={8} key={section.key}>
                <Card
                  hoverable
                  onClick={() => handleViewChange(section.key)}
                  style={{
                    textAlign: 'center',
                    border: `2px solid ${section.color}20`,
                    background: `${section.color}10`,
                    cursor: 'pointer'
                  }}
                  bodyStyle={{ padding: '12px' }}
                >
                  <div style={{ fontSize: 24, color: section.color, marginBottom: 8 }}>
                    {section.icon}
                  </div>
                  <Text strong style={{ fontSize: 13 }}>{section.label}</Text>
                </Card>
              </Col>
            ))}
          </Row>
        </Card>
     )}

      {/* راهنمای سیستم */}
      <Card 
        title={<Text strong style={{ fontSize: 14 }}>راهنمای استفاده از سیستم</Text>} 
        bodyStyle={{ padding: '16px' }}
        style={{ marginBottom: 12 }}
      >
        <Row gutter={[12, 12]}>
          <Col xs={24} md={6}>
            <Space direction="vertical" size={4} style={{ width: '100%' }}>
              <Space size={4}>
              <CheckCircleOutlined style={{ color: '#52c41a', fontSize: 20 }} />
               <GlobalOutlined style={{ color: '#13c2c2', fontSize: 20 }} />
            </Space>
              <Text strong style={{ fontSize: 13 }}> اطلاع رسانی و رزرو اتاق </Text>
              <Text type="secondary" style={{ fontSize: 12, lineHeight: '16px' }}>
                رزرو اتاق بر اساس تاریخ‌های اعلام شده در وب سایت اطلاع رسانی حسینیه قابل انجام می‌باشد
              </Text>
              <Button
                type="default"
                size="small"
                onClick={() => handleViewChange('website')}
                icon={<GlobalOutlined />}
              >
                وب‌سایت اطلاع رسانی
              </Button>
            </Space>
          </Col>
          <Col xs={24} md={6}>
            <Space direction="vertical" size={4} style={{ width: '100%' }}>
              <Space size={4}>
                <CoffeeOutlined style={{ color: '#722ed1', fontSize: 20 }} />
                <CarOutlined style={{ color: '#1890ff', fontSize: 20 }} />
              </Space>
              <Text strong style={{ fontSize: 13 }}>رزرو غذا و پارکینگ</Text>
              <Text type="secondary" style={{ fontSize: 12, lineHeight: '16px' }}>
                پس از ثبت نهایی اتاق و تایید دفتر حسینیه می‌توانید نسبت به رزرو غذا تا ۲ روز قبل از اقامت اقدام نمایید
              </Text>
            </Space>
          </Col>
          <Col xs={24} md={6}>
            <Space direction="vertical" size={4} style={{ width: '100%' }}>
              <SearchOutlined style={{ color: '#3a5a16ff', fontSize: 20 }} />
              <Text strong style={{ fontSize: 13 }}>مشاهده سوابق</Text>
              <Text type="secondary" style={{ fontSize: 12, lineHeight: '16px' }}>
                رزروهای قبلی شما در قسمت رزروهای من قابل مشاهده می‌باشد
              </Text>
            </Space>
          </Col>
          <Col xs={24} md={6}>
            <Space direction="vertical" size={4} style={{ width: '100%' }}>
              <Space>
                <QuestionCircleOutlined style={{ color: '#faad14', fontSize: 20 }} />
              </Space>
              <Text strong style={{ fontSize: 13 }}> راهنمای مراحل رزرو آنلاین </Text>
              <Text type="secondary" style={{ fontSize: 12, lineHeight: '16px', marginBottom: 4 }}>
                            برای آشنایی کامل با مراحل رزرو آنلاین، لطفاً راهنمای زیر را مطالعه نمایید
              </Text>
              <Button
                type="primary"
                href={pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                style={{ marginRight: 8 }}
              >
                PDF راهنمای مراحل رزرو آنلاین
              </Button>
            </Space>
          </Col>
        </Row>
      </Card>

      {/* فوتر اطلاعات */}
      <AppFooter 
        supportLinks={supportLinks}
        handleViewChange={handleViewChange}
      />
    </div>
  );
};